import { CommonModule, Location } from '@angular/common';
import { booleanAttribute, Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { debounce } from 'src/app/shared/utilities/debounce';

@Component({
    selector: 'nova-detail-toolbar',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatButtonModule],
    template: ` <div
        class="nova-toolbar"
        style="{{ styles }}">
        <div class="nova-toolbar__content">
            @if (showBackButton) {
                <div class="nova-toolbar__controls">
                    <button
                        mat-icon-button
                        type="button"
                        data-qa-id="ToolbarBackArrowButton"
                        (click)="goBack()"
                        data-cy="goBackBtn">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                </div>
            }

            @if (title) {
                <div class="nova-toolbar__title">{{ title }} </div>
            }

            @if (template) {
                <ng-container
                    [ngTemplateOutlet]="template"
                    [ngTemplateOutletContext]="{ data: templateData }"></ng-container>
            }
        </div>
    </div>`
})
export class DetailToolbarComponent {
    @Input({ transform: booleanAttribute }) showBackButton = true;
    @Input() title: string;
    @Input() template: TemplateRef<any>;
    @Input() templateData: unknown;
    @Input() styles: string;
    @Output() onGoBack: EventEmitter<void> = new EventEmitter<void>();
    @Input() submitReqButtonContent = '';
    @Output() onsubmitReqButtonClick: EventEmitter<void> = new EventEmitter<void>();
    constructor(private readonly location: Location) {
        this.goBack = debounce(this.goBack, 500);
    }

    goBack(): void {
        if (!this.onGoBack.observed) {
            this.location.back();
        } else {
            this.onGoBack.emit();
        }
    }
}
